import { SETTINGS_CATEGORIES } from "../constants/settings";
import { CATEGORY_LABELS } from "../constants/formRegistry";
import { SettingsLegalFooter } from "./SettingsLegalFooter";

interface SettingsListProps {
  onCategoryClick: (category: string) => void;
}

/**
 * SettingsList component displays the list of setting categories
 * Available on mobile as a full-page list
 */
export const SettingsList: React.FC<SettingsListProps> = ({
  onCategoryClick,
}) => {
  return (
    <div className="settings-list-container" id="settings-list">
      {/* Categories List */}
      <div className="settings-list-scroll">
        {SETTINGS_CATEGORIES.map((categoryId) => (
          <button
            key={categoryId}
            onClick={() => onCategoryClick(categoryId)}
            className="settings-list-item"
          >
            <span className="settings-list-label">
              {CATEGORY_LABELS[categoryId]}
            </span>
            <span className="settings-list-chevron" aria-hidden="true">
              ›
            </span>
          </button>
        ))}
      </div>

      {/* Legal Footer — FS-016 WP-1 */}
      <SettingsLegalFooter variant="mobile" />
    </div>
  );
};
